import React, { useEffect, useState } from "react";
import XMLViewer from "react-xml-viewer";

import HeaderPreview from "../documentDetails/preview/header";
import NonePreview from "../documentDetails/preview/nonePreview";

import "./style.css";

const EInvoice = props => {
  const {
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected,
    documentId,
    einvoiceType,
    fileName,
    isEinvoice,
    isInModal,
    myType,
    previewContent,
    setEinvoiceType,
    isDownloadVisible,
    setCurrentIndex,
    index
  } = props;

  const [iFrameHeight, setIFrameHeight] = useState("100%");
  const eInvoiceContent = isEinvoice
    ? previewContent
      .replace(/800px/gi, "100%")
      .replace(/min-width: 930px;/gi, "min-width: 100%;")
    : null;

  useEffect(() => {
    if (
      document.getElementsByTagName("iframe")[0] &&
      iFrameHeight === "100%" &&
      previewContent
    )
      setIFrameHeight(document.getElementsByTagName("iframe")[0].contentWindow.outerHeight +
          "px");
  }, []);

  return (
    <div className="modalContainer">
      {isInModal && (
        <HeaderPreview
          accountantSelected={accountantSelected}
          accountantIdSelected={accountantIdSelected}
          companySelected={companySelected}
          clientIdSelected={clientIdSelected}
          documentId={documentId}
          einvoiceType={einvoiceType}
          isDownloadVisible={isDownloadVisible}
          fileName={fileName}
          isEinvoice={isEinvoice}
          myType={myType}
          previewContent={previewContent}
          setEinvoiceType={setEinvoiceType}
          setCurrentIndex={setCurrentIndex}
          index={index}
        />
      )}

      <div>
        {previewContent && einvoiceType === "RAW" && (
          <div style={{ fontFamily: "monospace" }}>
            <XMLViewer
              xml={eInvoiceContent}
              theme={{
                attributeKeyColor: "#690",
                tagColor: "#905",
                attributeValueColor: "#07a",
                cdataColor: "#999",
                commentColor: "#999"
              }}
            />
          </div>
        )}

        {previewContent && einvoiceType !== "RAW" && (
          <iframe
            frameBorder="0"
            style={{
              width: "100%",
              height: iFrameHeight,
              overflow: "auto"
            }}
            height={iFrameHeight}
            // Changing the src of the iframe doesn't make it re-render with
            // the content from the new src. So we need the Preview
            // component to unmount and re-mount when the src changes. We
            // achieve that by changing the key prop
            key={"preview"}
            title={"previewContent"}
            className="c-Preview"
            srcDoc={eInvoiceContent}
          />
        )}

        {!previewContent && <NonePreview previewContent={previewContent} />}
      </div>
    </div>
  );
};

export default EInvoice;
